var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarginright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_5972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.639648 18.4541L13.7646 18.4541V17.3291H12.8271V16.2041H13.7646V15.0791H12.8271V13.9541H13.7646L13.7646 12.8291H12.8271V11.7041H13.7646V10.5791H12.8271V9.4541H13.7646V8.3291H12.8271V7.2041H13.7646V6.0791H12.8271V4.9541H13.7646L13.7646 3.8291H12.8271V2.7041H13.7646V1.5791H12.8271V0.454102L0.639648 0.454102L0.639648 18.4541ZM11.8896 1.5791L11.8896 17.3291L1.57715 17.3291L1.57715 1.5791L11.8896 1.5791ZM14.7021 18.4541V17.3291H15.6396V18.4541H14.7021ZM13.7646 17.3291V16.2041H14.7021V17.3291H13.7646ZM14.7021 16.2041V15.0791H15.6396V16.2041H14.7021ZM13.7646 15.0791V13.9541H14.7021V15.0791L13.7646 15.0791ZM14.7021 13.9541L14.7021 12.8291H15.6396L15.6396 13.9541H14.7021ZM13.7646 12.8291V11.7041H14.7021V12.8291H13.7646ZM14.7021 11.7041V10.5791H15.6396V11.7041H14.7021ZM13.7646 10.5791V9.4541H14.7021V10.5791H13.7646ZM14.7021 9.4541V8.3291L15.6396 8.3291V9.4541L14.7021 9.4541ZM13.7646 8.3291V7.2041H14.7021V8.3291H13.7646ZM14.7021 7.2041V6.0791L15.6396 6.0791V7.2041L14.7021 7.2041ZM13.7646 6.0791V4.9541H14.7021V6.0791H13.7646ZM14.7021 4.9541L14.7021 3.8291L15.6396 3.8291L15.6396 4.9541L14.7021 4.9541ZM13.7646 3.8291V2.7041H14.7021V3.8291H13.7646ZM14.7021 2.7041V1.5791H15.6396V2.7041L14.7021 2.7041ZM13.7646 1.5791V0.454102H14.7021V1.5791H13.7646Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_5972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.639648 18.4541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginright);
export default __webpack_public_path__ + "static/media/marginright.d8cc05d59724f704be87c9c9f04c06f4.svg";
export { ForwardRef as ReactComponent };